module.exports = __webpack_public_path__ + "static/media/2.d98a9632.svg";